import * as Effects from 'redux-saga/effects'
import { servicesAccepted } from '../../actions/bookingCalendar/reservationModal/servicesAccepted'
import {
  IToggleServicesModal,
  toggleServicesModal,
  toggleServicesModalLoading,
} from '../../actions/bookingCalendar/reservationModal/toggleServicesModal'
import { callFetch } from '../../actions/fetch'
import fireToastError from '../../actions/toasts/fireToastError'
import i18n from '../../i18n'
import fetchRates from '../../models/Services/fetchRates'
import fetchServices from '../../models/Services/fetchServices'
import { ServicesModal } from '../../reducers/bookingCalendar/actionNames'
import { getSelectedLanguage } from '../../reducers/userAccount/selectors/userLanguage'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'

function* loadServices(action: IToggleServicesModal) {
  if (!action.toggle) {
    return
  }

  yield Effects.put(toggleServicesModalLoading(true))
  try {
    yield Effects.put({ type: PaymentDictionaryActions.RequestTaxes })
    yield Effects.put({ type: PaymentDictionaryActions.RequestInvoiceSetting })
    const actionNames = fetchActionsName(ActionNames.LoadServices)
    const actionNamesRates = fetchActionsName('Fetch tax rates form API' as any)
    const [{ service }, { service: ratesService }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.take(actionNamesRates.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchServices),
      ),
      Effects.put(
        callFetch(actionNames.input, actionNamesRates.output, fetchRates),
      ),
    ])

    const lang = yield Effects.select(getSelectedLanguage)
    const services = yield Effects.call(service, lang)
    const rates = yield Effects.call(ratesService)
    yield Effects.put(servicesAccepted(services, rates))
  } catch (e) {
    yield Effects.put(toggleServicesModal(false))
    yield Effects.put(fireToastError(i18n.t('errStatus_999')))
  }
}

export default function*() {
  yield Effects.takeLatest(ServicesModal.ToggleServicesModal, loadServices)
}
